import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <section className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">{t('notFound.title')}</h1>
      <p className="text-sm text-[var(--color-muted-foreground)]">{t('notFound.description')}</p>
      <Button asChild variant="outline" size="sm">
        <Link to="/">{t('common.backToDashboard')}</Link>
      </Button>
    </section>
  );
}
